"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAirportCodeFromCdn = exports.fetchAirportCodeFromCloudflare = exports.fetchAirportCodeFromFastly = exports.fetchAirportCodeFromAmazon = void 0;
const utils_1 = require("@streamr/utils");
const logger = new utils_1.Logger(module);
const fetchHeader = async (url, header, timeout) => {
    const response = await (0, utils_1.withTimeout)(fetch(url, {
        method: 'HEAD'
    }), timeout);
    return response.headers.get(header);
};
const fetchAirportCodeFromAmazon = async (url, timeout) => {
    const header = await fetchHeader(url, 'X-Amz-Cf-Pop', timeout);
    // parse airport code from the first 3 characters of X-Amz-Cf-Pop header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Amazon');
    }
    const airportCode = header.substring(0, 3);
    return airportCode;
};
exports.fetchAirportCodeFromAmazon = fetchAirportCodeFromAmazon;
const fetchAirportCodeFromFastly = async (timeout) => {
    const header = await fetchHeader('https://www.fastly.com', 'X-Served-By', timeout);
    // parse airport code from the last 3 characters of X-Served-By header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Fastly');
    }
    const airportCode = header.substring(header.length - 3);
    return airportCode;
};
exports.fetchAirportCodeFromFastly = fetchAirportCodeFromFastly;
const fetchAirportCodeFromCloudflare = async (timeout) => {
    const header = await fetchHeader('https://www.cloudflare.com', 'CF-RAY', timeout);
    // parse airport code from the last 3 characters of CF-RAY header
    if (!header || header.length < 3) {
        throw new Error('Could not get airport code from Cloudflare');
    }
    const airportCode = header.substring(header.length - 3);
    return airportCode;
};
exports.fetchAirportCodeFromCloudflare = fetchAirportCodeFromCloudflare;
const fetchAirportCodeFromCdn = async () => {
    const timeout = 2000;
    // try to get airport code from the first CDN that responds
    // if one fails, try the next one
    try {
        return await (0, exports.fetchAirportCodeFromAmazon)('https://d47ahk2wrqweh.cloudfront.net/cdn-location', timeout);
    }
    catch (error) {
        logger.warn(error);
    }
    try {
        return await (0, exports.fetchAirportCodeFromFastly)(timeout);
    }
    catch (error) {
        logger.warn(error);
    }
    try {
        return await (0, exports.fetchAirportCodeFromCloudflare)(timeout);
    }
    catch (error) {
        logger.warn(error);
    }
    throw new Error('Could not get airport code from any CDN');
};
exports.fetchAirportCodeFromCdn = fetchAirportCodeFromCdn;
//# sourceMappingURL=fetchAirportCodeFromCdn.js.map